import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';

const buttonWidth = Theme.BU * 11;
const baseStyles = StyleSheet.create({
    container: {
        flex: 1
    },
    imageContainer: {
        flexGrow: 1,
        padding: 20,
    },
    buttonContainer: {
        padding: 20,
        justifyContent: Device.isTabletOrWeb ? 'center' : 'space-between',
        alignItems: 'center',
        flexDirection: 'row',
        flexWrap: 'wrap'
    },
    button: {
        width: Device.isTabletOrWeb ? 'auto' : '100%',
        minWidth: Device.isTabletOrWeb ? buttonWidth : '40%',
        marginBottom: 20,
        marginHorizontal: Device.isTabletOrWeb ? 10 : 'auto',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    }
});

export default baseStyles;
